import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import * as fromGraphQl from './issue-status.graphql';
import { ApolloService } from '../apollo.service';
import { IssueStatus } from '../../entities/issue/issue-status';

@Injectable()
export class IssueStatusService {
  constructor(private apolloService: ApolloService) {}

  public getIssueStatuses(): Observable<IssueStatus[]> {
    return this.apolloService
      .query<fromGraphQl.GetIssueStatusesResponse>(fromGraphQl.GET_STATUSES_QUERY)
      .pipe(
        take(1),
        switchMap((result) => {
          return of(IssueStatus.createIssueStatuses(result.data.getIssueStatuses));
        })
      );
  }
}
